<template>
  <div class="bosy">
    <div class="sunText">
      <div class="categoryAll">
        <div>{{$t('data.headText.pageTwo.name')}}</div>
      </div>
      <ul v-if="msg">
        <li v-for="(item,index) in msg.child" :key="index" style="list-style:none">
          <div class="category">{{item.title}}</div>
          <ul class="sunpop">
            <li
              @click="part(item2.id,item2.title,item.child)"
              v-for="(item2,index) in item.child"
              :key="index"
            >{{item2.title}}</li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="zhuji">
      <div class="delback" @click="delbackbot">
        <p class="fanh" @click="retn">
          <img src="../assets/guanwangback.svg" alt>返回
        </p>
      </div>
      <div
        style="display:flex;padding-bottom:76px;border-bottom:2px solid rgba(215,215,215,1);margin-bottom:23px"
      >
        <p class="leftphoto">
          <img :src="docy.img + '?x-oss-process=image/resize,h_800'" alt class="img">
        </p>
        <div class="rightz">
          <span class="btn btn-primary buttondity,">Suncare</span>
          <p class="texty">{{docy.name}}</p>
          <span class="textmon">¥{{docy.price}}</span>
          <!-- <span class="textmon">{{docy.price}}} (¥{{docy.price}}})</span> -->
          <p class="disp">
            <span>Size Small,Medium,Large Material</span>
            <br>
            <span>Materia겉감 표면: Nylon83%,Polyurethan17% 겉감 이면:Nylon100%(Neoprene)</span>
            <br>
            <span>Release 2017-04-20</span>
            <br>
            <span>Manufacture ：Vietnam</span>
          </p>
          <p class="xuanz">{{$t('data.headText.pagenine.shop')}}</p>

          <div>
            <select defaultValue="lucy" class="shur" @change="handleChange">
              <option value="jack">{{$t('data.headText.pagenine.chima')}}</option>
              <option value="jack">xl</option>
              <option value="lucy">xxl</option>
            </select>
          </div>
          <div style="margin-top:30px">
            <select defaultValue="lucy" class="shur" placeholder="请选择颜色" @change="handleChange">
              <option value="jack">{{$t('data.headText.pagenine.yasn')}}</option>
              <option value="jack">{{$t('data.headText.pagenine.hongs')}}</option>
              <option value="lucy">{{$t('data.headText.pagenine.bais')}}</option>
            </select>
          </div>
          <p class="hus">
            <span class="sp1">{{$t('data.headText.pagenine.shops')}}</span>
            <span class="sp2">{{$t('data.headText.pagenine.shuli')}} :</span>
            <span class="sp1">$0</span>
            <span class="sp2">(0 件) / (¥0)</span>
          </p>

          <div class="fout">
            <img :src="JD" alt>
            <img :src="tian" alt>
            <div class="but1 but">{{$t('data.headText.pagenine.houmai')}}</div>
            <div class="but2 but">{{$t('data.headText.pagenine.shoupcar')}}</div>
          </div>
        </div>
        <br>
        <div>
          <p class="margin:300px">
            <img :src="docy.img + '?x-oss-process=image/resize,h_310'" alt class="img">
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JD from "../assets/JD.png";
import retu from "../assets/return.png";
import tian from "../assets/tianmao.png";

export default {
  data() {
    return {
      id: "",
      JD: JD,
      retu: retu,
      tian: tian,
      docy: {
        name: "",
        min_img: "",
        img: "",
        pid: "",
        id: "",
        price: "",
        language: ""
      },
      msg: {},
      bannerid: "",
      clothesBuid: [],
      classid: "",
      bannerid: ""
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.bannerid = this.$route.query.bannerid;
    this.classid = this.$route.query.index;
    this.init();
    var data = JSON.parse(localStorage.getItem("muenall"));
    this.msg = data[this.classid];
    this.clothesBuid = data[this.classid].child[0].child;
  },
  methods: {
    handleChange(value) {},
    retn() {
      this.$router.go(-1); //返回上一层
    },
    init() {
      this.req
        .post(
          "http://jd1.vvc.tw/index/goods/getGoodsInfo",
          this.qs.stringify({
            id: this.id
          })
        ).then(res => {
          if (res.data.code == 1) {
            console.log(res.data.data)
            this.docy = {
              name: "",
              min_img: "",
              img: "",
              pid: "",
              id: "",
              price: "",
              language: ""
            };
            this.docy = {
              name: res.data.data.name,
              min_img: res.data.data.img,
              img: res.data.data.img,
              pid: res.data.data.pid,
              id: res.data.data.id,
              price: res.data.data.price,
            };
          }
        });
    },

    part(i, a, c) {
      this.$router.push({
        path: "/integration",
        query: {
          id: this.classid,
          bannerid: i
        }
      });
    },
    delbackbot() {}
  }
};
</script>
<style  scoped>
.bosy {
  width: 1920px;
  height: 100%;
  display: flex;
  margin: 0 auto;
}
.zhuji {
  /* border: 1px solid red; */
  background: white;
  margin-top: 150px;
  padding: 0 60px;
  box-sizing: border-box;
  overflow: hidden;
}
.delback {
  cursor: pointer;
}
.leftphoto {
  float: left;
  width: 480px;
  height: 678px;
  margin-right: 35px;
}
.leftphoto img {
  width: 480px;
  height: 678px;
}
.rightz {
  float: right;
  width: 480px;
  height: 678px;
  margin-right: 30%;
}
.texty {
  width: 369px;
  height: 52px;
  font-size: 22px;
  margin-top: 33px;
  font-family: SFUIText-Regular;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 26px;
}
.textmon {
  display: block;
  width: 205px;
  height: 29px;
  font-size: 24px;
  font-family: SFUIText-Medium;
  font-weight: 500;
  color: rgba(74, 74, 74, 1);
  line-height: 29px;
  margin: 33px 0 33px 0;
}
.disp {
  width: 449px;
  height: 92px;
  font-size: 12px;
  font-family: SFUIText-Medium;
  font-weight: 500;
  color: rgba(155, 155, 155, 1);
  line-height: 23px;
}
.xuanz {
  width: 200px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(74, 74, 74, 1);
  line-height: 25px;
  margin: 33px 0 33px 0;
}
.shur {
  width: 475px;
  height: 38px;
}
.hus {
  width: 238px;
  height: 28px;
  color: rgba(155, 155, 155, 1);
  margin-top: 32px;
  margin-left: 240px;
  margin-bottom: 44px;
}
.sp1 {
  font-size: 20px;
}
.sp2 {
  font-size: 14px;
}
.fout {
  display: flex;
}
.but {
  width: 148px;
  height: 58px;
  background: rgba(74, 144, 226, 1);
  border-radius: 1px;
  display: inline-block;
  margin-left: 20px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 58px;
}
.but2 {
  color: rgba(155, 155, 155, 1);
  background: rgba(236, 236, 236, 1);
}
.bus1 {
  margin: auto;
  margin-top: 20px;
  width: 64px;
  height: 22px;

  line-height: 22px;
}
.bus2 {
  margin: auto;
  text-align: center;
  margin-top: 20px;
  width: 148px;
  height: 38px;
  background: rgba(236, 236, 236, 1);
  border-radius: 1px;
}

.fout img {
  width: 48px;
  height: 48px;
  margin: 10px;
}
.sunText {
  width: 300px;
  padding-left: 40px;
  box-sizing: border-box;
  margin-top: 135px;
}

.fanh {
  font-size: 18px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(74, 144, 226, 1);
  margin-bottom: 46px;
}
.fanh img {
  width: 18px;
  height: 18px;
}
/* .categoryAll {
     margin-right: 40px;
      height: 82px;
      width: 220px;
      font-size: 30px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(74, 74, 74, 1);
      line-height: 82px;
      border-bottom: 1px solid rgba(87, 198, 235, 1)
} */
.categoryAll div {
  margin-right: 40px;
  height: 82px;
  width: 220px;
  font-size: 30px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
  line-height: 82px;
  border-bottom: 1px solid rgba(87, 198, 235, 1);
}
.category {
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
  line-height: 28px;
  margin: 20px 0 20px 0;
}
.sunpop {
  width: 220px;
  padding-bottom: 8px;
  border-bottom: 1px solid #57c6eb;
}

.sunpop li {
  height: 38px;
  font-size: 16px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: rgba(74, 74, 74, 1);
  line-height: 38px;
  cursor: pointer;
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/doc.vue